import gql from 'graphql-tag';
import { client } from 'shared/containers/apollo';

const LOG_RESET_SESSION = gql`
  query logResetSession($input: String) {
    logResetSession(input: $input)
  }
`;

export default async function logResetSessionAsync(input: string): Promise<boolean> {
  return client.query({
    query: LOG_RESET_SESSION,
    fetchPolicy: 'no-cache',
    variables: {
      input,
    },
  }) as unknown as boolean;
}
